import { Iata } from 'types/Search/airport';
import { AirportValue } from 'types/Search/filter';

export const convertUrlParamToValue = (param: string): AirportValue<Iata> =>
    new Set(param.split(',') as Iata[]);

export const convertValueToUrlParam = (value: AirportValue<Iata>): string =>
    [...value].join(',');
